import React from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {BREADCRUMBS_REPORTS} from "@pages/reports/constants/breadcrumbs";
import AllReportsSingleVoyage from "@pages/singleVoyage/reports/allReports/AllReportsSingleVoyage";
import {SxType} from "@baseTypes/sx/sxTypes";
import ReportBackToVoyagesSingleVoyage
    from "@containers/singleVoyage/reports/ui/backToVoyages/ReportBackToVoyagesSingleVoyage";

const sx: SxType = {
    root: {
        padding: '0 10px'
    },
    back: {
        margin: '8px 10px 0',
    }
}
const AllReportsSingleVoyagePage = () => {

    return (
        <PageLayout
            breadcrumbs={BREADCRUMBS_REPORTS}
        >
            <ReportBackToVoyagesSingleVoyage sx={sx.back}/>
            <AllReportsSingleVoyage sx={sx.root}/>
        </PageLayout>
    )
};

export default AllReportsSingleVoyagePage;